import { TranslationKeys } from "./TranslationKey";

export const de: TranslationKeys = {
  "application.examLocationAndDate.chkeckingAvailabilityOfExams": "Prüfung der Prüfungsverfügbarkeit. Bitte warten...",
  "application.examLocationAndDate.dateColumn": "Datum",
  "application.examLocationAndDate.examColumn": "Prüfung",
  "application.examLocationAndDate.examFull": "Leider sind alle Prüfungsplätze bereits vergeben. Wir empfehlen Ihnen sich in der Warteliste einzutragen.",
  "application.examLocationAndDate.examTypeColumn": "Prüfungstyp",
  "application.examLocationAndDate.languageColumn": "Sprache",
  "application.examLocationAndDate.locationColumn": "Standort",
  "application.examLocationAndDate.moduleColumn": "Modul",
  "application.examLocationAndDate.statusColumn": "Status",
  "application.examLocationAndDate.validattion.examsHaveDifferentLocations": "Es ist nicht möglich am gleichen Tag Prüfungen an unterschiedlichen Standorten zu buchen. Bitte passen Sie ihre Auswahl an.",
  "application.examLocationAndDateExplanationText": "Bitte wählen Sie Ort und Datum für die ausgewählten Prüfungen.",
  "application.moduleSelector.examsColumn": "Prüfungen",
  "application.moduleSelector.noAvaiableModules": "Keine Module verfügbar",
  "application.moduleSelector.typeColumn": "Typ",
  "application.selectedExamsTitle": "Ausgewählte Module und Prüfungen",
  "application.uploadVerificationFilesMessage": "Laden Sie bitte alle Dokumente zur Validierung der Teiläquivalenz hoch.",
  "application.userSelector.course": "Lehrgang",
  "application.userSelector.examSession": "Prüfungssession",
  "application.userSelector.noSelectedModules": "Keine ausgewählten Module",
  "cancellationTaskForm.candidateSubHeader": "Kandidat",
  "cancellationTaskForm.certificationTypeLabel": "Zertifizierung",
  "cancellationTaskForm.commentsLabel": "Kommentar",
  "cancellationTaskForm.completeTask": "Aufgabe speichern und abschliessen",
  "cancellationTaskForm.createdOn": "Erstellt am:",
  "cancellationTaskForm.dateLabel": "Datum",
  "cancellationTaskForm.emailLabel": "E-Mail",
  "cancellationTaskForm.examTypeLabel": "Prüfungstyp",
  "cancellationTaskForm.firstNameLabel": "Vorname",
  "cancellationTaskForm.header": "Stornierungs-Aufgabe",
  "cancellationTaskForm.lastNameLabel": "Nachname",
  "cancellationTaskForm.locationLabel": "Standort",
  "cancellationTaskForm.moduleSubHeader": "Modul",
  "cancellationTaskForm.navigateToCandidateSession": "Anmeldungen des Kandidaten öffnen",
  "cancellationTaskForm.roomLabel": "Raum",
  "cancellationTaskForm.sessionLabel": "Session",
  "cancellationTaskForm.timeSlotLabel": "Zeit",
  "candidate.button.exportAll": "Alle Kandidaten exportieren",
  "candidate.button.new": "Neuen Kandidat hinzufügen",
  "candidate.button.uploadEdiIds": "EDI-IDs hochladen",
  "candidate.disableConfirmationDialog.message": "Bitte vergewissern Sie sich, dass Ihre Personalien korrekt sind, da sie anschliessend nicht mehr geändert werden können.",
  "candidate.ediIdsDialog.title": "Wählen Sie die Datei, welche die EDI-IDs enthält.",
  "candidate.ediIdsDialog.uploadSuccess": "Upload erfolgreich: Anzahl aktualisierte Kandidaten:",
  "candidate.field.canton": "Kanton",
  "candidate.field.correspondenceLanguage": "Korrespondenz-Sprache ",
  "candidate.field.invoiceRecipient": "Rechnungsempfänger",
  "candidate.field.nationality": "Nationalität",
  "candidate.field.numberOfFailedOralExams": "Fehlgeschlagene mündliche Prüfungen",
  "candidate.field.numberOfFailedWrittenExams": "Fehlgeschlagene schriftliche Prüfungen",
  "candidate.field.placeOfOrigin": "Heimatort",
  "candidate.header": "Kandidaten",
  "candidate.section.invoice": "Rechnung",
  "candidate.snackbar.successfulCreate": "Kandidat wurde hinzugefügt.",
  "candidate.snackbar.successfulDelete": "Der gewählte Kandidat wurde gelöscht.",
  "candidate.snackbar.successfulExport": "Der Export der Abacus-Debitorennummer wurde der Warteschlange hinzugefügt",
  "candidate.snackbar.successfulUpdate": "Änderungen wurden gespeichert.",
  "candidate.validation.disabledFields": "Felder können nach der Bestätigung nicht mehr aktualisiert werden",
  "candidate.validation.idNotEmpty": "Die Kandidaten-ID darf nicht leer sein.",
  "candidateAssignment.validation.preparationRoomNotAllowed.": "Ein Kandidat kann nicht einem Vorbereitungsraum zugewiesen werden.",
  "candidateCourse.certificate.fileNamePrefix": "Zertifikat",
  "candidateCourse.performanceRecord.fileNamePrefix": "Leistungsnachweis",
  "candidateCourseStatus.open": "Offen",
  "candidateCourseStatus.passed": "Bestanden",
  "candidateWizard.error": "Die Anmeldung ist fehlgeschlagen. Versuchen Sie es erneut oder melden Sie sich beim VBV.",
  "candidateWizard.success": "Gratulation! Sie sollten für jede Buchung eine E-Mail erhalten haben und Ihre Prüfungen werden in der Kandidatenansicht angezeigt.",
  "canton.ag": "Aargau",
  "canton.ai": "Appenzell Innerrhoden",
  "canton.ar": "Appenzell Ausserrhoden",
  "canton.be": "Bern",
  "canton.bl": "Basel-Landschaft",
  "canton.bs": "Basel-Stadt",
  "canton.fr": "Freiburg",
  "canton.ge": "Genf",
  "canton.gl": "Glarus",
  "canton.gr": "Graubünden",
  "canton.ju": "Jura",
  "canton.lu": "Luzern",
  "canton.ne": "Neuenburg",
  "canton.nw": "Nidwalden",
  "canton.ow": "Obwalden",
  "canton.sg": "St. Gallen",
  "canton.sh": "Schaffhausen",
  "canton.so": "Solothurn",
  "canton.sz": "Schwyz",
  "canton.tg": "Thurgau",
  "canton.ti": "Tessin",
  "canton.ur": "Uri",
  "canton.vd": "Waadt",
  "canton.vs": "Wallis",
  "canton.zg": "Zug",
  "canton.zh": "Zürich",
  "cart.validation.candidateIdNotEmpty": "Kandidaten-ID darf nicht leer sein.",
  "cart.validation.cartEmpty": "Der Warenkorb ist leer.",
  "cart.validation.examAlreadyBooked": "Prüfung bereits gebucht.",
  "cart.validation.examNotFound": "Prüfung nicht gefunden.",
  "cart.validation.missingCourseId": "Fehlende Kurs-ID",
  "cart.validation.missingExamDayIdOnExam": "Fehlende Prüfungstag-Id bei der Prüfung.",
  "cart.validation.missingExamSessionId": "Fehlende Prüfungssessions-Id",
  "cart.validation.missingInformationInModule": "Fehlende Informationen zum Modul.",
  "cart.validation.missingModuleId": "Fehlende Modul-ID",
  "cart.validation.moduleAlreadyBooked": "Modul bereits gebucht.",
  "cart.validation.moduleAlreadyPaid": "Modul bereits bezahlt.",
  "cart.validation.moduleNotFound": "Modul nicht im Warenkorb gefunden.",
  "certification.button.new": "Prüfungsanmeldung",
  "certification.examDate": "Prüfungsdatum",
  "certification.examType": "Prüfungstyp",
  "certification.fachrichtung": "Option mündlicher Prüfungsfall",
  "certification.state": "Status",
  "certifications.noInfo": "Keine Zertifizierungen vorhanden",
  "common.accept": "Bestätigen",
  "common.archive": "Archivieren",
  "common.attention": "Achtung",
  "common.build": "Erstellen",
  "common.business": "Geschäft",
  "common.cancel": "Abbrechen",
  "common.certificationsGenerated": "Zertifikate generiert",
  "common.close": "Schliessen",
  "common.comment": "Kommentar",
  "common.confirmArchiveDescription": "Möchten Sie die Entität wirklich archivieren?",
  "common.confirmDeleteDescription": "Möchten Sie die Entität wirklich löschen?",
  "common.confirmPublishDescription": "Möchten Sie die Entität wirklich veröffentlichen?",
  "common.copyToClipboard": "In die Zwischenablage kopieren",
  "common.copyToClipboardDone": "In die Zwischenablage kopiert",
  "common.debtorNumber": "Debitorennummer",
  "common.delete": "Löschen",
  "common.dragAndDrop.description": "Das Dokument hier per Drag&Drop ablegen",
  "common.errorMessage": "Etwas ist schief gelaufen",
  "common.exam": "Prüfung",
  "common.export": "Exportieren",
  "common.field.status": "Status",
  "common.genders.female": "Weiblich",
  "common.genders.male": "Männlich",
  "common.generateCertifications.confirmation": "Möchten Sie wirklich Zertifikate generieren?",
  "common.generateCertifications": "Zertifikate generieren",
  "common.info": "Information",
  "common.language.de": "Deutsch",
  "common.language.en": "Englisch",
  "common.language.fr": "Französisch",
  "common.language.it": "Italienisch",
  "common.language": "Sprache",
  "common.languages": "Sprachen",
  "common.lastModification.by": "von",
  "common.lastModification.on": "am",
  "common.lastModification": "Zuletzt geändert",
  "common.module": "Modul",
  "common.no": "Nein",
  "common.noLanguagesAssigned": "Keine zugewiesenen Sprachen",
  "common.ok": "Ok",
  "common.orderId": "Bestellnummer",
  "common.pleaseSelect": "Bitte Wählen",
  "common.private": "Privat",
  "common.publish": "Veröffentlichen",
  "common.reject": "Ablehnen",
  "common.rejected": "Abgelehnt",
  "common.roomLanguage": "Raumsprache",
  "common.roomType": "Raumtyp",
  "common.rowsPerPage": "Zeilen pro Seite:",
  "common.save": "Speichern",
  "common.scheduleCorrectionExams": "Korrekturplanung",
  "common.scheduleOralExams": "Prüfungsplanung mündlich",
  "common.scheduleWrittenExams": "Prüfungsplanung schriftlich",
  "common.search": "Suche",
  "common.selectElement": "Wähle ein",
  "common.selectElements": "Wähle eines",
  "common.signOut": "Abmelden",
  "common.status.archived": "Archiviert",
  "common.status.cancelled": "Storniert",
  "common.status.deleted": "Gelöscht",
  "common.status.draft": "Entwurf",
  "common.status.published": "Veröffentlicht",
  "common.survey": "Umfrage",
  "common.timeSlotStructure": "Zeitsloststruktur",
  "common.total": "Total",
  "common.transaction.failMessage.declined": "Der Zahlungsanbieter hat die Zahlung abgelehnt. Bitte versuchen Sie eine andere Zahlungsmethode.",
  "common.transaction.id": "Transaktions-ID",
  "common.unexpectedError": "Unerwarteter Fehler. Bitte versuchen Sie es später erneut.",
  "common.Unknown": "Unbekannt",
  "common.unpublish": "Veröffentlichung zurückziehen",
  "common.uploadError": "Fehler beim Upload. Das Dateiformat ist ungültig.",
  "common.uploadSizeError": "Upload-Fehler. Die Datei überschreitet die maximale Größe von {size}MB.",
  "common.validation.entityWithIdNotExistsAndCanNotBeAssigned": "Die Entität mit der angegebenen ID wurde nicht gefunden und kann nicht zugeordnet werden.",
  "common.validation.entityWithIdNotExistsAndCanNotBeDeleted": "Die Entität mit der angegebenen ID wurde nicht gefunden und kann nicht gelöscht werden.",
  "common.validation.idNotEmpty": "Die ID darf nicht leer sein.",
  "common.validation.name.empty": "Der Name darf nicht leer sein.",
  "common.validation.status.empty": "Der Status darf nicht leer sein.",
  "common.validation.status.invalidTransition": "Dieser Statusübergang ist ungültig.",
  "common.validation.status.invalidValue": "Ungültiger Statuswert.",
  "common.yes": "Ja",
  "countries.switzerland.name": "Schweiz",
  "course.button.addModules": "Module hinzufügen",
  "course.dialog.confirmPublishDescription": "Möchten Sie die Lehrgänge wirklich veröffentlichen?",
  "course.dialog.noAvailableModules": "Keine Module verfügbar.",
  "course.dialog.selectModules": "Module auswählen",
  "course.field.certificateValidity.FiveYears": "5 Jahre",
  "course.field.certificateValidity.Unlimited": "Unbeschränkt",
  "course.field.certificateValidity": "Gültigkeit der Zertifizierung",
  "course.field.moduleRelevantForGrade": "Relevant für Lehrgangsnote",
  "course.field.modulesValidity.days": "Tage",
  "course.field.modulesValidity.unlimited": "Unbegrenzt",
  "course.field.modulesValidity": "Modulgültigkeit",
  "course.field.name": "Lehrgangsname",
  "course.field.nameDE": "Lehrgangsname - DE",
  "course.field.nameEN": "Lehrgangsname - EN",
  "course.field.nameFR": "Lehrgangsname - FR",
  "course.field.nameIT": "Lehrgangsname - IT",
  "course.field.numberOfMandatoryModules": "Anzahl obligatorische Module",
  "course.field.numberOfProcessModules": "Anzahl Prozessmodule",
  "course.field.numberOfSelectionModules": "Anzahl Wahlmodule",
  "course.header": "Lehrgang",
  "course.list.header": "Lehrgänge",
  "course.section.modules": "Modules",
  "course.snackbar.successfulArchive": "Der gewählte Lehrgang wurde archiviert.",
  "course.snackbar.successfulDelete": "Der gewählte Lehrgang wurde gelöscht.",
  "course.snackbar.successfulPublish": "Der gewählte Lehrgang wurde veröffentlichen.",
  "course.type.cicero": "Fachausweis/Cicero",
  "course.type.ciceroGroup": "Fachausweis/Cicero Gruppe",
  "course.type.hve": "HBB",
  "course.type.hveGroup": "HBB Gruppe",
  "course.type.intermediary": "Vermittler",
  "course.type.intermediaryGroup": "Vermittler Gruppe",
  "course.type.mindeststandard": "Mindeststandards",
  "course.type.mindeststandardGroup": "Mindeststandards Gruppe",
  "course.type": "Lehrgangstyp",
  "course.validation.idNotEmpty": "Die ID der Lehrgang darf nicht leer sein.",
  "course.validation.modules.empty": "Bitte wählen Sie mindestens ein Modul aus.",
  "course.validation.numberOfAnyModulesIsZero": "Die Gesamtzahl der Module muss mindestens 1 betragen.",
  "course.validation.typeIsInvalid": "Der Kurstyp ist ungültig.",
  "course.validation.typeNotEmpty": "Bitte selektieren sie den Lehrgangstyp",
  "courseManagement.header": "Lehrgänge",
  "dragAndDrop.uploadFiles": "Laden Sie die Dateien hoch, indem Sie sie hier ablegen",
  "exam.button.new": "Neue Prüfung hinzufügen",
  "exam.field.correctionExpenses": "Korrekturspesen",
  "exam.field.courseType": "Kurstyp",
  "exam.field.examExpenses": "Prüfungsspesen",
  "exam.field.examId": "Prüfungs-ID",
  "exam.field.examName": "Prüfungsname",
  "exam.field.examNameDE": "Prüfungsname DE",
  "exam.field.examNameEN": "Prüfungsname EN",
  "exam.field.examNameFR": "Prüfungsname FR",
  "exam.field.examNameIT": "Prüfungsname IT",
  "exam.field.expertExpenses": "Expertenspesen",
  "exam.field.type": "Prüfungstyp",
  "exam.header": "Prüfungen",
  "exam.section.specifics": "Prüfungs spezifisch",
  "exam.snackbar.successfulArchive": "Der gewählte Prüfung wurde archiviert.",
  "exam.snackbar.successfulDelete": "Der gewählte Prüfung wurde gelöscht.",
  "exam.snackbar.successfulPublish": "Der gewählte Prüfung wurde veröffentlichen.",
  "exam.type.oral": "Mündliche Prüfung",
  "exam.type.termPaper": "Schriftliche Arbeit",
  "exam.type.written": "Schriftliche Prüfung",
  "exam.validation.idNotEmpty": "Der Prüfungsname darf nicht leer sein",
  "examApplication.field.candidates": "Kandidaten",
  "examApplication.field.case": "Prüfungsaufgabe",
  "examApplication.validation.timeslotIsOverbooked": "Mindestens eine Prüfung ist überbucht. Dies kann passieren, wenn neue Anmeldungen hinzugefügt werden, während Änderungen in der Planungsansicht vorgenommen werden.",
  "examAssignment.validation.preparationRoomNotAllowed": "Eine Prüfung kann nicht einem Vorbereitungsraum zugewiesen werden.",
  "examDay.button.assignExpertsToCorrectionExams": "Korrekturexperte zuweisen",
  "examDay.button.assignExpertsToOralExams": "Prüfungsexperten für mündliche Prüfung zuweisen",
  "examDay.button.assignProctorsToOralPreparations": "Aufsichtsexperten für Vorbereitungsraum zuweisen",
  "examDay.button.assignProctorsToWrittenExams": "Aufsichtsexperten für schriftliche Prüfung zuweisen",
  "examDay.button.new": "Neuen Prüfungstag hinzufügen",
  "examDay.field.date": "Datum",
  "examDay.field.header": "Prüfungstag",
  "examDay.field.numberOfRoomsAssigned": "Zugewiesene Räume",
  "examDay.field.preparationRoom": "Vorbereitungsraum",
  "examDay.field.timeSlotStructure.correction": "Korrektur",
  "examDay.field.timeSlotStructure.electiveWritten": "Wahl schriftlich",
  "examDay.field.timeSlotStructure.mandatoryWritten": "Obligatorisch schriftlich",
  "examDay.field.timeSlotStructure.oralHBB_ProcessModule": "Mündlich HBB Prozessmodul",
  "examDay.field.timeSlotStructure.oralIntermediary": "Mündlich Vermittler",
  "examDay.field.timeSlotStructure.oralLife": "Prüfungsteil Leben",
  "examDay.field.timeSlotStructure.placeholder": "Zeitfenster",
  "examDay.field.timeSlotStructure.writtenHBB_ProcessModule": "Schriftlich HBB Prozessmodul",
  "examDay.field.timeSlotStructure.writtenIntermediary": "Schriftlich Vermittler",
  "examDay.field.timeSlotStructure": "Zeitfenster",
  "examDay.field.type.correction": "Korrektur",
  "examDay.field.type.oral": "Mündlich",
  "examDay.field.type.written": "Schriftlich",
  "examDay.field.type": "Typ",
  "examDay.validation.alreadyExistsForLocationOnSameDate": "Ein weiterer Prüfungstag mit dem gleichen Datum und Standort existiert bereits.",
  "examDay.validation.examTypeUnknown": "Die Prüfungsart ist unbekannt. Bitte wählen Sie eine existierende Prüfungsart aus.",
  "examDay.validation.idNotEmpty": "Die Prüfungstag-ID darf nicht leer sein.",
  "examDay.validation.notFound": "Prüfungstag nicht gefunden.",
  "examDay.validation.onlyOnePreparationRoomAllowed": "Der Tag kann nur um einen Vorbereitungsraum erweitert werden.",
  "examDay.validation.roomCanNotBeAssignedToSelectedExamType": "Der Raum kann nicht zugewiesen werden, da er für die Prüfungsart dieses Prüfungstages nicht anwendbar ist.",
  "examDay.validation.selectedRoomAlreadyAssigned": "Der Raum ist bereits zugeordnet.",
  "examDay.validation.selectedRoomIsPcRoomAndCanNotBeUsed": "Der Raum ist ein PC-Raum und kann nicht zugewiesen werden.",
  "examManagement.header": "Prüfungen",
  "examScore.grade": "Note",
  "examScore.points": "Punkte",
  "examSession.alert.builderInformation": "Bitte beachten Sie, dass die oben ausgewählte Prüfung an allen Tagen allen ausgewählten Räumen zugewiesen wird. Sie können Ihre Eingaben nach der Erstellung der Prüfungssession überprüfen und manuell ändern. Das Startdatum der Registrierung ist automatisch der heutige Tag und die Startzeit 10 Uhr vormittags.",
  "examSession.button.calculateExamResults": "Prüfungsergebnisse berechnen",
  "examSession.button.exportCandidates": "Kandidaten für Prüfungstyp und/oder Zeit exportieren",
  "examSession.button.exportOrders": "Fehlende/pendente Bestellungs-XML exportieren",
  "examSession.button.importExamScoresAndGrades": "Punkte und Noten importieren",
  "examSession.button.importPev": "PEV importieren",
  "examSession.button.new": "Eine neue Prüfungssession hinzufügen",
  "examSession.button.newBuilder": "Mit Builder hinzufügen",
  "examSession.button.newLife": "Eine neue Lebens-Prüfungssession hinzufügen",
  "examSession.button.publishExamResults": "Prüfungsergebnisse veröffentlichen",
  "examSession.candidateExportDialog.examDay.label": "Datum",
  "examSession.candidateExportDialog.examDay.placeholder": "Datum auswählen",
  "examSession.candidateExportDialog.timeSlot.label": "Zeit",
  "examSession.candidateExportDialog.timeSlot.placeholder": "Zeit auswählen",
  "examSession.candidateExportDialog.title": "Wählen Sie den Prüfungstyp und eine Zeit (optional)",
  "examSession.confirmPublishResultsDialog.text": "Sind Sie sicher, dass Sie die Prüfungsergebnisse zu dieser Session veröffentlichen wollen?",
  "examSession.dialog.noAvailableCourses": "Diese Prüfung ist keinem Kurs zugeordnet.",
  "examSession.dialog.selectCourseTypes": "Kursarten auswählen",
  "examSession.field.candidatePin": "Kandidaten-PIN",
  "examSession.field.correctionPeriod": "Korrekturzeitraum",
  "examSession.field.date": "Verabredung",
  "examSession.field.examResultDate": "Zeitpunkt Prüfungsresultat",
  "examSession.field.examSession": "Prüfungszeitraum",
  "examSession.field.examSessionDate": "Datum der Prüfungssession",
  "examSession.field.expertPin": "Experten-PIN",
  "examSession.field.freeCancellationEndDate": "Kostenfrei stornierbar bis",
  "examSession.field.from": "Von",
  "examSession.field.gradingConferenceDate": "Erwahrungssitzungsdatum",
  "examSession.field.hidePastSessions": "Vergangene Sitzungen ausblenden",
  "examSession.field.inspectionPeriod": "Einsichtnahme",
  "examSession.field.inspectionSignupEndDate": "Anmeldeschluss für Einsichtnahme",
  "examSession.field.isLife": "Lebensprüfung",
  "examSession.field.lifeSessionsOnly": "Nur Lebens-Prüfungen",
  "examSession.field.published": "Veröffentlicht",
  "examSession.field.sessionKey": "Prüfungssession",
  "examSession.field.sessionKeyDE": "Prüfungssession DE",
  "examSession.field.sessionKeyEN": "Prüfungssession EN",
  "examSession.field.sessionKeyFR": "Prüfungssession FR",
  "examSession.field.sessionKeyIT": "Prüfungssession IT",
  "examSession.field.signup": "Registrierung",
  "examSession.field.signupDate": "Anmeldedatum",
  "examSession.field.signupEndDate": "Enddatum der Registrierung",
  "examSession.field.signupStartDate": "Startdatum für die Registrierung",
  "examSession.field.surveyDeadline": "Deadline der Umfrage",
  "examSession.field.to": "Bis",
  "examSession.header": "Prüfungssessionen",
  "examSession.importPevDialog.title": "Laden Sie die Datei mit den PEV-Daten hoch",
  "examSession.invitation.allLocations": "Alle Standorte",
  "examSession.invitation.flagged": "Für diesen Standort wurden die E-Mails bereits versendet",
  "examSession.invitation.selectLocations": "Standort auswählen",
  "examSession.invitation.snackbar.candidates": "Die Prüfungseinladungen wurde an {count} Kandidaten versendet.",
  "examSession.invitation.snackbar.experts": "Die Prüfungseinladungen wurde an {count} Experten versendet.",
  "examSession.invitation": "Experten/Kandidaten einladen",
  "examSession.label.examSessionBuilder": "Prüfungssession-Builder",
  "examSession.label.revealCandidatePin": "Kandidaten-PIN anzeigen",
  "examSession.label.revealExpertPin": "Experten-PIN anzeigen",
  "examSession.mail.invitation": "Prüfungseinladungen versenden",
  "examSession.mail.notifyCandidates": "Kandidaten über Prüfungsergebnisse informieren",
  "examSession.mail.survey": "Verfügbarkeitsumfrage für Experten starten",
  "examSession.result.examSessionCreated": "Die Prüfungssession wurde erfolgreich erstellt.",
  "examSession.result.NotGenerated": "Prüfungsergebnisse wurden noch nicht generiert.",
  "examSession.select.assignNewLocation": "Neuen Standort zuweisen",
  "examSession.validation.atLeastOneLanguageIsSelectedForEachRoom": "Für jeden Raum muss mindestens eine Sprache ausgewählt werden.",
  "examSession.validation.betweenFromAndTo": "Die Zeitspanne für die Registrierung muss zwischen dem Von- und Bis-Datum liegen.",
  "examSession.validation.canNotBeDeletedBecauseLocationsInside": "Die Prüfungssession kann nicht gelöscht werden, da sie einen oder mehrere Standorte zugewiesen hat.",
  "examSession.validation.canNotBeUnpublishedBecauseExistingApplication": "Veröffentlichung der Prüfungssession kann nicht aufgehoben werden, weil es bereits existierende Registrierungen zu Prüfungen gibt.",
  "examSession.validation.canNotReapplyForDifferentLanguage": "Sie können sich nicht erneut für dieselbe Prüfungssitzung mit einer anderen Sprache anmelden.",
  "examSession.validation.correctionEndDateLaterThanCorrectionStartDate": "Das Enddatum der Korrektur muss nach dem Startdatum der Korrektur liegen.",
  "examSession.validation.examsEndDateLaterThanExamsStartDate": "Das Enddatum der Prüfung muss nach dem Startdatum der Prüfung liegen. ",
  "examSession.validation.examSessionFull": "Die ausgewählte Prüfung in dieser Prüfungssession ist in der Zwischenzeit leider ausgebucht. Bitte wählen Sie ein anderes Modul oder eine andere Prüfungssession",
  "examSession.validation.examsNoCourseTypes": "Einigen schriftlichen oder mündlichen Prüfungen ist kein Kurstyp zugeordnet. Bitte ordnen Sie mindestens einen Kurstyp zu.",
  "examSession.validation.examWithNotAllowedCourseTypes": "Einigen Prüfungen sind keine gültigen Kurstypen zugeordnet. Bitte stellen Sie sicher, dass alle Zuweisungen korrekt sind oder laden Sie die Seite neu.",
  "examSession.validation.freeCancellationNotPossible": "Kostenfreie Stornierung nicht mehr möglich",
  "examSession.validation.idNotEmpty": "Die Prüfungs-ID darf nicht leer sein.",
  "examSession.validation.inspectionEndDateLaterThanInspectionStartDate": "Das Enddatum der Inspektion muss nach dem Startdatum der Inspektion liegen.",
  "examSession.validation.locationAlreadyExists": "Der Standort ist bereits in der Prüfungssession vorhanden.",
  "examSession.validation.locationDoesNotExist": "Der Standort wurde nicht gefunden.",
  "examSession.validation.nameIsRequiredInAllLanguages": "Der Name der Prüfungssitzung ist in allen Sprachen erforderlich.",
  "examSession.validation.noExamFoundToSignup": "Keine Prüfung zur Anmeldung gefunden.",
  "examSession.validation.notPublishedNoSurveyPossible": "Umfrage kann nur gestartet werden, wenn die Prüfungssession veröffentlicht ist.",
  "examSession.validation.notPublishedResultsPublishingNotPossible": "Die Veröffentlichung der Prüfungsergebnisse ist nicht möglich, da die Prüfungssession nicht veröffentlicht wird.",
  "examSession.validation.publishedNoUpdatePossible": "Die Prüfungssession ist veröffentlicht und kann nicht aktualisiert werden.",
  "examSession.validation.signupEndDateLaterThanSignupStartDate": "Das Enddatum der Registrierung muss nach dem Startdatum der Registrierung liegen.",
  "examSession.validation.signupStartDateLaterThanOrEqualFrom": "Das Startdatum der Registrierung muss gleich oder später sein als das Von-Datum.",
  "examSession.validation.someErrorsOccurred": "Einige Module sind fehlerhaft",
  "examSession.validation.toLaterThanFrom": "Das Enddatum der Prüfung muss nach dem Startdatum der Prüfung liegen.",
  "examSession.validation.toLaterThanSignupEndDate": "Das Enddatum der Prüfung muss nach dem Enddatum der Einschreibung liegen.",
  "examSession.validation.toLaterThanSignupStartDate": "Das Enddatum der Prüfung muss nach dem Startdatum der Anmeldung liegen.",
  "examSession.validation.withSameNameAlreadyExists": "Eine andere Prüfungssession mit dem gleichen Namen existiert bereits.",
  "examSession.writtenExamScoresImportDialog.title": "Laden Sie die Datei hoch, welche die Prüfungsergebnisse enthält",
  "examSession.writtenExamScoresImportDialog.uploadSuccess": "Upload erfolgreich. Aktualisierte Resultate:",
  "examSessionCandidate.addCandidate": "Kandidat hinzufügen",
  "examSessionCandidate.addDialog.bookingWithInvoice": "Buchung mit Rechnung",
  "examSessionCandidate.addDialog.candidate": "Kandidat",
  "examSessionCandidate.addDialog.course": "Lehrgang",
  "examSessionCandidate.addDialog.module": "Modul",
  "examSessionCandidate.addDialog.rebookWithInvoice": "Erneut buchen mit Rechnung",
  "examSessionCandidate.addDialog.title": "Kandidat, Lehrgang und Modul auswählen",
  "examSessionCandidate.attachments": "Anhänge",
  "examSessionCandidate.averageGrade": "Durchschnittsnote",
  "examSessionCandidate.book": "Buchen",
  "examSessionCandidate.bookedBy": "Buchende/r",
  "examSessionCandidate.booking.error": "Ihre Auswahl ist nicht mehr verfügbar. Bitte versuchen Sie es erneut.",
  "examSessionCandidate.bookingAvailableWhenRebooked": "Die Prüfungsauswahl wird verfügbar sein, wenn das Modul neu gebucht wird.",
  "examSessionCandidate.bookingDialog.selectDate": "Datum wählen",
  "examSessionCandidate.bookingDialog.selectLanguage": "Wählen Sie eine Sprache",
  "examSessionCandidate.bookingDialog.selectLocation": "Standort wählen",
  "examSessionCandidate.bookingDialog.title": "Standort und Prüfungsdatum",
  "examSessionCandidate.bookingTimestamp": "Buchungszeitpunkt",
  "examSessionCandidate.cancel": "Stornieren",
  "examSessionCandidate.cancellationTimestamp": "Stornierungszeitpunkt",
  "examSessionCandidate.cancelledBy": "Stornierende/r",
  "examSessionCandidate.cancelModuleMessage": "Sind Sie sicher, dass Sie dieses Modul stornieren wollen?",
  "examSessionCandidate.cancelModuleRefundInformation": "Innerhalb der kostenlosen Stornierungsfrist wird das Modul erstattet, andernfalls wird eine Stornierungsaufgabe erstellt.",
  "examSessionCandidate.certification": "Zertifizierung",
  "examSessionCandidate.exam": "Prüfung",
  "examSessionCandidate.examDate": "Prüfungsdatum",
  "examSessionCandidate.examType": "Prüfungstyp",
  "examSessionCandidate.isRepeater": "Repetent",
  "examSessionCandidate.locationAndDateEdit": "Standort und Prüfungsdatum bearbeiten",
  "examSessionCandidate.module": "Modul",
  "examSessionCandidate.option": "Option",
  "examSessionCandidate.orderDetails": "Bestelldetails",
  "examSessionCandidate.paymentState": "Bezahlstatus",
  "examSessionCandidate.publishResultsToEmployer": "Prüfungsresultat weitergeben",
  "examSessionCandidate.rebook": "Erneut buchen",
  "examSessionCandidate.resetManualState": "Status automatisch festlegen",
  "examSessionCandidate.selectExamToRebook": "Wählen Sie eine Prüfung zur erneuten Buchung aus",
  "examSessionCandidate.setManualState": "Status manuell festlegen",
  "examSessionCandidate.state": "Status",
  "examSessionCandidate.validation.examAlreadyBookedForAnotherModule": "Die Prüfung ist bereits für ein anderes Modul gebucht.",
  "examSessionCandidate.validation.examNotFound": "Die Prüfung wurde nicht gefunden.",
  "examSessionCandidate.validation.idNotEmpty": "Die ExamSessionCandidate ID darf nicht leer sein.",
  "examSessionCandidate.validation.invalidGrade": "Die Note ist ungültig.",
  "examSessionCandidate.validation.invalidScore": "Die Punktzahl ist ungültig.",
  "examSessionCandidate.verificationRequired": "Verifizierung erforderlich",
  "examSessionCandidateExamState.booked": "Gebucht",
  "examSessionCandidateExamState.cancelled": "Storniert",
  "examSessionCandidateExamState.equivalence": "Äquivalenz",
  "examSessionCandidateExamState.failed": "Prüfung nicht bestanden",
  "examSessionCandidateExamState.passed": "Prüfung bestanden",
  "examSessionCandidateModuleState.applicationAccepted": "Anmeldung akzeptiert",
  "examSessionCandidateModuleState.Cancelled": "Modul storniert. Eine Systemaufgabe wurde erstellt",
  "examSessionCandidateModuleState.cancelled": "Storniert",
  "examSessionCandidateModuleState.equivalence": "Äquivalenz",
  "examSessionCandidateModuleState.expired": "Abgelaufen",
  "examSessionCandidateModuleState.failed": "Modul nicht bestanden",
  "examSessionCandidateModuleState.passed": "Modul bestanden",
  "examSessionCandidateModuleState.Refunded": "Modul zurückerstattet",
  "examSessionCandidateModuleState.verificationRequired": "Verifizierung erforderlich",
  "examSessions.noInfo": "Keine Prüfungssessionen verfügbar",
  "examState.booked": "Gebucht",
  "examState.cancelled": "Storniert",
  "examState.none": "---",
  "expert.button.new": "Neuen Experten hinzufügen",
  "expert.field.courseType.placeholder": "Trainingstypen für die Rolle auswählen",
  "expert.field.exam.placeholder": "Prüfungen für die Rolle auswählen",
  "expert.field.exam": "Examen",
  "expert.field.languages": "Sprachen",
  "expert.field.role.add": "Neue rolle hinzufügen",
  "expert.field.role.Aufsichtsexperten": "Aufsichtsexpert*in",
  "expert.field.role.delete": "Rolle löschen",
  "expert.field.role.EinspracheKomission": "Einsprachekomission",
  "expert.field.role.Expertenschulung": "Expertenschulung",
  "expert.field.role.Hauptexperten": "Hauptexpert*in",
  "expert.field.role.Leiterprüfungszentrum": "Leiter*in Prüfungszentrum",
  "expert.field.role.placeholder": "Rollen für Experten wählen",
  "expert.field.role.Prüfungsexperten": "Prüfungsexpert*in",
  "expert.field.role.Prüfungskomission": "Prüfungskomission",
  "expert.field.role.QSK": "Qualitätssicherungskomission",
  "expert.field.role": "Rollen",
  "expert.header": "Experten",
  "expert.snackbar.successfulCreate": "Experte wurde hinzugefügt.",
  "expert.snackbar.successfulDelete": "Der gewählte Prüfung wurde gelöscht.",
  "expert.snackbar.successfulUpdate": "Änderungen wurden gespeichert.",
  "expert.validation.idNotEmpty": "Die Experten-ID darf nicht leer sein.",
  "expertAssignment.validation.examNotAssignedToRoom": "Prüfung ohne Raumzuweisung",
  "expertAssignment.validation.expertAssignedToMultipleRoomsOnSameDay": "Experte ist verschiedenen Räumen am selben Tag zugeordnet.",
  "expertAssignment.validation.expertNotRequiredRole": "Experte hat nicht die benötigte Rolle.",
  "expertAssignment.validation.expertNotSpeakingAnySupportedLanguage": "Der Experte spricht keine der benötigten Sprachen.",
  "expertAssignment.validation.roomNotAssignedToExamDay": "Der Raum ist nicht dem Prüfungstag zugeordnet.",
  "expertAvailability.header": "Verfügbarkeit",
  "expertAvailability.noDatesAvailable": "Aktuell sind keine Termine verfügbar.",
  "expertAvailability.surveyDeadlinePassed": "Die Frist für die Eingabe der Verfügbarkeit ist abgelaufen",
  "expertCorrectionAvailability.header": "Verfügbarkeit für Prüfungskorrektur",
  "file.name": "Dateiname",
  "home.candidate": "Ansicht der Kandidaten",
  "home.expert": "Ansicht eines Experten",
  "home.header": "Startseite",
  "home.me.edit": "Konto verwalten",
  "home.me": "Ich und meine Einstellungen",
  "home.myAlertFields.link": "Bitte verwalten Sie Ihr Konto.",
  "home.myAlertFields": "Es sind einige Pflichtangaben notwendig.",
  "home.myCertifications": "Meine Zertifizierungen",
  "home.myCourses.downloadCertificate": "Zertifikat",
  "home.myCourses.downloadPerformanceRecord": "Leistungsnachweis",
  "home.myCourses.table.ClosingDate": "Abschlussdatum",
  "home.myCourses.table.downloads": "Downloads",
  "home.myCourses": "Meine Lehrgänge",
  "home.myExamCases": "Prüfungsaufgaben",
  "home.myExamResults": "Prüfungsergebnisse",
  "home.myExams.newApplication": "Prüfungsanmeldung",
  "home.myExams.noExams": "Keine Prüfungen verfügbar",
  "home.myExams.table.actionsColumn": "Aktionen",
  "home.myExams.table.dateColumn": "Datum",
  "home.myExams.table.examColumn": "Prüfung",
  "home.myExams.table.examTypeColumn": "Prüfungtyp",
  "home.myExams.table.gradeColumn": "Note",
  "home.myExams.table.locationColumn": "Standort",
  "home.myExams.table.moduleColumn": "Modul",
  "home.myExams.table.roomColumn": "Raum",
  "home.myExams.table.statusColumn": "Status",
  "home.myExams.table.timeColumn": "Zeit",
  "home.myExams": "Meine Prüfungen",
  "home.myExamSessions": "Meine Prüfungssessionen",
  "home.myFiles": "Meine Dokumente",
  "home.myTasks": "Meine Aufgaben",
  "home.pendingItemsInCartMessage": "Sie haben noch nicht bezahlte Module. Möchten Sie die Buchung nun fortsetzen? Bitte beachten Sie, dass der Platz in einem Modul bis zur Bezahlung nicht reserviert wird.",
  "home.switch.candidate": "Zur Kandidatenansicht wechseln",
  "home.switch.expert": "Zur Expertenansicht wechseln",
  "icon.state.completed": "Abgeschlossen",
  "icon.state.error": "Fehler",
  "icon.state.fullyBooked": "Ausgebucht",
  "icon.state.incomplete": "Unvollständig",
  "icon.state.paid": "Bezahlt",
  "import.pev.bookingFailed": "Es können nicht alle Kandidaten gebucht werden.",
  "import.pev.failedImportCandidates": "Importieren von Kandidaten fehlgeschlagen.",
  "import.pev.failedImportScoresAndGrades": "Importieren von Ergebnissen und Noten fehlgeschlagen.",
  "import.pev.invalidCsv": "Ungültige CSV-Datei.",
  "import.pev.missingEntities": "Einige Entitäten wurden nicht gefunden. Kandidaten IDs: {KandidatenIds}. Prüfungssitzungen IDs: {examSessionsIds}. Kurse IDs: {courseIds}. Module IDs: {moduleIds}. Prüfungen IDs: {examIds}.",
  "import.pev.noExam": "Prüfung kann nicht gefunden werden. Prüfungs-ID: {examId}.",
  "import.pev.noExamDayForExam": "Kann keinen verfügbaren Prüfungstag für die Prüfung finden. ID der Prüfungssitzung: {examSessionId}. Prüfungs-ID: {examId}. Sprache: {language}.",
  "import.pev.success": "Die PEV-Daten wurden erfolgreich importiert.",
  "import.pev.wrongCourseModules": "Module sind nicht mit dem Kurs verknüpft. Kurs-ID: {courseId}. Module IDs: {moduleIds}.",
  "import.pev.wrongExamSessionExams": "Prüfungen sind nicht mit der Prüfungssitzung verknüpft. ID der Prüfungssitzung: {examSessionId}. Prüfungs-IDs: {examIds}.",
  "import.pev.wrongModuleExams": "Die Prüfungen sind nicht mit dem Modul verknüpft. Modul-ID: {moduleId}. Prüfungen IDs: {examIds}.",
  "lifeExams.back": "Zurück",
  "lifeExams.book": "Buchen",
  "lifeExams.confirm": "Bestätigen",
  "lifeExams.label.displayFullyBooked": "Auch ausgebuchte Sessions anzeigen",
  "lifeExams.label.register": "Auswählen",
  "lifeExams.label.sesionFullyBooked": "Keine freien Plätze",
  "lifeExams.messages.courseNotFound": "Der Kurs wurde nicht gefunden.",
  "lifeExams.messages.infoAlertAddUpdateOrConfirmPersonalData": "Bitte erfassen, aktualisieren oder bestätigen Sie Ihre persönlichen Daten bevor Sie eine Prüfung buchen.",
  "lifeExams.messages.infoAlertExams": "Es werden nur freie Prüfungsplätze in {lang} angezeigt.",
  "lifeExams.messages.infoAlertExamSessions": "Es werden nur Monate mit freien Prüfungsplätzen angezeigt",
  "lifeExams.messages.noAvailableExams": "Keine Prüfungen verfügbar",
  "lifeExams.messages.warnAlertReservation": "Bitte beachten Sie, dass Ihr Platz bis zur Bezahlung nicht reserviert ist.",
  "lifeExams.pay": "Buchen + Bezahlen",
  "lifeExams.paymentErrorInitializing": "Fehler beim Initialisieren der Zahlung",
  "lifeExams.redirectToMyVbv": "Weiterleitung zu MyVBV in {secondsLeft} Sekunden",
  "lifeExams.sessionAlreadyBooked": "Prüfungssession bereits gebucht",
  "lifeExams.title": "Prüfungstermin auswählen",
  "lifeExams.transactionCancelled": "Transaktion {transactionId} wurde abgebrochen",
  "lifeExams.transactionFailed": "Fehler bei Transaktion {transactionId}. Grund: ",
  "lifeExams.transactionPaid": "Sie sind für die Prüfung angemeldet und erhalten in Kürze per Mail eine Buchungsbestätigung.",
  "lifeExams.waitingList": "Warteliste",
  "location.button.new": "Neuen Ort hinzufügen",
  "location.field.canton.placeholder": "Wählen Sie einen Kanton",
  "location.field.canton": "Kanton",
  "location.field.city": "Ort",
  "location.field.contactEmailAddress": "Kontaktperson Email",
  "location.field.contactName": "Kontaktperson Name",
  "location.field.contactPhoneNo": "Kontaktperson Tel.-Nr",
  "location.field.languageRegions": "Sprachregionen",
  "location.field.linkToMap": "Lageplan",
  "location.field.name": "Name",
  "location.field.street": "Strasse",
  "location.field.zipCode": "PLZ",
  "location.header": "Standorte",
  "location.validation.idNotEmpty": "Die Standort-ID darf nicht leer sein.",
  "location.validation.languageUnknown": "Die Sprache ist unbekannt. Bitte wählen Sie eine existierende Sprache aus.",
  "location.validation.nameAlreadyExists": "Ein weiterer Standort mit dem gleichen Namen existiert bereits.",
  "location": "Standort",
  "login.button.adminLogin": "Login VBV-Admin",
  "login.button.impressum": "Impressum",
  "login.button.impressumLink": "https://www.vbv.ch/de/impressum",
  "login.button.login": "Login",
  "login.error.errorLoadingAppRegistration": "Fehler beim Abrufen der Konfiguration.",
  "login.text.external1": "Melden Sie sich an, um auf die Anwendung zuzugreifen.",
  "login.text.external2": "Bitte verwenden Sie einen modernen Browser wie Chrome oder Edge. Diese Plattform funktioniert ausschliesslich mit Notebook oder Desktop. Mit Tablet oder Handy funktioniert sie nicht.",
  "login.text.externalWarn": "Wichtig",
  "login.title.external": "Anmeldung als Kandidat/Experte",
  "module.button.new": "Neues Modul hinzufüngen",
  "module.dialog.confirmPublishDescription": "Möchten Sie die Prüfung wirklich veröffentlichen?",
  "module.dialog.noAvailableExams": "Keine Prüfungen verfügbar.",
  "module.dialog.noAvailableLocations": "Keine Standorte verfügbar.",
  "module.dialog.selectExams": "Prüfungen auswählen",
  "module.dialog.selectLocations": "Standorte auswählen",
  "module.field.abacusNumber": "Abacus Nummer",
  "module.field.allowDocumentUpload": "Dokumentupload erlauben",
  "module.field.allowOptions": "Optionen erlauben",
  "module.field.allowRegistrationOnlyOnce": "Einmalig verfügbar",
  "module.field.allRoomsAssigned": "Zugewiesener Raum",
  "module.field.certificateValidity.FiveYears": "5 Jahre",
  "module.field.certificateValidity.OneYear": "1 Jahr",
  "module.field.certificateValidity.Unlimited": "Unbeschränkt",
  "module.field.certificateValidity": "Zertifikat gültig für",
  "module.field.documentsUploaded": "Dokumente hochgeladen",
  "module.field.gradingRules.allExams": "Alle Prüfungen müssen bestanden werden",
  "module.field.gradingRules.averageGrade": "Durchschnittsnote",
  "module.field.gradingRules": "Benotungsregeln",
  "module.field.moduleId": "Modul ID",
  "module.field.moduleName": "Modulname",
  "module.field.moduleNameDE": "Modulname DE",
  "module.field.moduleNameEN": "Modulname EN",
  "module.field.moduleNameFR": "Modulname FR",
  "module.field.moduleNameIT": "Modulname IT",
  "module.field.moduleType.mandatory": "Obligatorisch",
  "module.field.moduleType.optionalModule": "Wahlmodul",
  "module.field.moduleType.processModule": "Prozessmodul",
  "module.field.moduleType": "Modultyp",
  "module.field.needsApproval": "Braucht zulassung",
  "module.field.paymentState": "Bezahlstatus",
  "module.field.price": "Preis in CHF",
  "module.field.verificationRequired": "Verifizierung erforderlich",
  "module.header": "Module",
  "module.moduleDetails": "Moduldetails",
  "module.section.specifics": "Modul spezifisch",
  "module.snackbar.successfulArchive": "Der gewählte Modul wurde archiviert.",
  "module.snackbar.successfulDelete": "Der gewählte Modul wurde gelöscht.",
  "module.snackbar.successfulPublish": "Der gewählte Modul wurde veröffentlichen.",
  "module.validation.gradingRule.invalidValue": "Ungültiger Wert für Benotungsregeln.",
  "module.validation.idNotEmpty": "Die Module ID darf nicht leer sein.",
  "module.validation.invalidStatusTransition": "Dieser Statusübergang ist nicht gültig.",
  "module.validation.invalidStatusValue": "Ungültiger Statuswert.",
  "module.validation.statusNotEmpty": "Das Status darf nicht leer sein.",
  "oralExamOption.kmu": "Kleine und mittlere Unternehmen",
  "oralExamOption.none": "Keine",
  "oralExamOption.privathaushalte": "Privathaushalte",
  "paymentMethodSelector.form.button": "Bezahlen per Rechnung",
  "paymentMethodSelector.item.creditCard": "Kreditkarte / Twint",
  "paymentMethodSelector.item.invoice": "Rechnung",
  "paymentMethodSelector.item.invoiceMessage": "Privatadresse (CH)",
  "paymentMethodSelector.title": "Wählen Sie die Zahlungsmethode",
  "paymentStatus.paid.abacus": "Fakturiert (Abacus)",
  "paymentStatus.paid.ePayment.cembraPay": "Bezahlt (E-Payment: CembraPay)",
  "paymentStatus.paid.ePayment.creditCard": "Bezahlt (E-Payment: Kreditkarte / Twint)",
  "paymentStatus.refunded.abacus": "Rückerstattet (Abacus)",
  "paymentStatus.refunded.ePayment.cembraPay": "Rückerstattet (E-Payment: CembraPay)",
  "paymentStatus.refunded.ePayment.creditCard": "Rückerstattet (E-Payment: Kreditkarte / Twint)",
  "person.field.activateSpecificProfile": "Expertenprofil aktivieren",
  "person.field.ahvNumber": "AHV-Nummer",
  "person.field.bankAccount": "Bankkonto",
  "person.field.birthDate": "Geb. Datum",
  "person.field.ciceroNumber": "Cicero-Nummer",
  "person.field.city": "Wohnort",
  "person.field.country": "Land",
  "person.field.displayName": "Name",
  "person.field.email": "E-Mail",
  "person.field.employer": "Arbeitgeber",
  "person.field.employerCity": "Ort",
  "person.field.employerCountry": "Wählen Sie ein Land",
  "person.field.employerStreet": "Strasse",
  "person.field.employerStreetNumber": "Nummer",
  "person.field.employerZipCode": "PLZ",
  "person.field.firstName": "Vorname",
  "person.field.gender.placeholder": "Wählen Sie ein Geschlecht aus",
  "person.field.gender": "Geschlecht",
  "person.field.homeCountry": "Heimatland",
  "person.field.icon": "Akteurensymbol",
  "person.field.internalComment": "Interner Kommentar",
  "person.field.lastName": "Nachname",
  "person.field.mobileNumber": "Mobile",
  "person.field.phoneNumber.placeholder": "Format: +41123456789",
  "person.field.phoneNumber": "Telefon",
  "person.field.showOnlyExperts": "Nur Experten anzeigen",
  "person.field.street": "Strasse",
  "person.field.streetNumber": "Nummer",
  "person.field.zipCode": "PLZ Wohnort",
  "person.section.address": "Privatadresse",
  "person.section.businessData": "Geschäftsdaten",
  "person.section.expertDetails": "Fachspezifische Details",
  "person.section.personalDetails": "Personalien",
  "person.validation.ahvNumberAlreadyExists": "Ein anderer Benutzer mit derselben AHV-Nummer existiert bereits.",
  "person.validation.ahvNumberNotValid": "Die AHV-Nummer ist ungültig.",
  "person.validation.bankAccountNotEmpty": "Das Bankkonto kann nicht leer sein",
  "person.validation.ciceroNumberAlreadyExists": "Ein anderer Benutzer mit derselben Cicero-Nummer existiert bereits.",
  "person.validation.ciceroNumberNotValid": "Die Cicero-Nummer ist ungültig.",
  "person.validation.confirmEmailChange": "Die E-Mail-Adresse wurde geändert. Dadurch wird die E-Mail-Adresse, welche für die Anmeldung benötigt wird, ebenfalls geändert. Sind Sie sicher, dass Sie fortfahren möchten?",
  "person.validation.emailAlreadyExists": "Ein anderer Benutzer mit der gleichen E-Mail existiert bereits.",
  "person.validation.genderUnknown": "Das Geschlecht ist unbekannt. Bitte wählen Sie ein existierendes Geschlecht aus.",
  "person.validation.invalidEmployerZipCode": "PLZ ist ungültig.",
  "person.validation.invalidZipCode": "PLZ Wohnort ist ungültig.",
  "person.validation.mandatoryExamRolesWithNoExams": "Es gibt obligatorische Prüfungsrollen, denen keine Prüfungen zugewiesen sind. Bitte weisen Sie die fehlenden Prüfungen zu.",
  "person.validation.personEdiIdNotEmpty": "Die EDI-ID darf nicht leer sein",
  "person.validation.personEmailAddressNotEmpty": "Die E-Mail-Adresse darf nicht leer sein",
  "person.validation.repeatedRoles": "Es gibt mehrere Rollen. Bitte achten Sie darauf, dass sich die Rollen nicht wiederholen.",
  "person.validation.typeUnknown": "Der Personentyp ist unbekannt. Bitte wählen Sie einen vorhandenen Typ aus.",
  "role.validation.roleUnknown": "Unbekannte Rolle",
  "room.button.new": "Neue Räume",
  "room.field.floor": "Stockwerk",
  "room.field.isPcRoom": "Computerraum",
  "room.field.name": "Name",
  "room.field.numberOfSeats": "Kapazität",
  "room.header": "Raum",
  "room.text.seats": "Plätze",
  "room.validation.idNotEmpty": "Die Raum-ID darf nicht leer sein.",
  "room.validation.nameAlreadyExists": "Ein anderer Raum mit dem gleichen Namen existiert bereits.",
  "roomAssignment.button.new": "Neue Raumzuweisung",
  "roomAssignment.deleteConfirmation.title": "Sie sind dabei, einen Vorbereitungsraum zu entfernen. Bitte stellen Sie sicher, dass diesem Prüfungstermin ein Vorbereitungsraum zugewiesen ist.",
  "roomAssignment.field.isPreparationRoom": "Vorbereitungsraum",
  "roomAssignment.field.room.placeholder": "Wählen Sie einen Raum aus",
  "roomAssignment.field.room": "Raum",
  "roomAssignment.header": "Raumzuweisung",
  "roomAssignment.validation.idNotEmpty": "Die Raumzuweisung kann nicht leer sein",
  "scheduler.examSelectDialog.title": "Prüfung für den Raum wählen",
  "scheduler.examSelectDialog.tooltip": "Prüfung für alle Zeitfenster wählen",
  "scheduler.message.briefing": "Experteninformation",
  "scheduler.message.exam": "Prüfung",
  "scheduler.message.noExperts": "Keine Experten zugewiesen",
  "scheduler.message.pause": "Pause",
  "scheduler.timeSlot.arrivalTime": "Ankunftszeit",
  "selfcancellation.header": "Modul stornieren",
  "selfcancellation.text": "Achtung! Bitte bestätigen Sie, dass Sie Ihre Anmeldung zur Prüfung stornieren wollen.",
  "startCertification.button.back": "Zurück",
  "startCertification.button.finish": "Fertig stellen",
  "startCertification.button.next": "Weiter",
  "startCertification.courseModuleExamsStep.header": "Lehrgang, Modul und Prüfungen wählen",
  "startCertification.examDataStep.header": "Prüfungstermin wählen",
  "startCertification.examDataStep.selectCompany": "Arbeitgeber auswählen",
  "startCertification.examDataStep.selectExamSession": "Prüfungssession auswählen",
  "startCertification.examDataStep.selectFachrichtung": "Fachrichtung auswählen",
  "startCertification.examDataStep.selectLocationOralPart": "Standort für mündliche Prüfung wählen",
  "startCertification.examDataStep.selectLocationWrittenPart": "Standort für schrifliche Prüfung wählen",
  "startCertification.examDataStep.selectOralExamDate": "Datum für mündliche Prüfung wählen",
  "startCertification.examDataStep.selectWrittenExamDate": "Datum für schriftliche Prüfung wählen",
  "startCertification.locationDateStep.header": "Prüfungsort und Termin wählen",
  "startCertification.modulesDetailsStep.dialogHelperText": "Bitte ergänzen Sie die fehlenden Informationen und laden Sie bitte gegebenfalls die erforderlichen Dokumente hoch.",
  "startCertification.modulesDetailsStep.docsText1": "Laden Sie bitte alle Dokumente hoch, die für dieses Modul erforderlich sind.",
  "startCertification.modulesDetailsStep.docsText2": "Falls Sie die Dokumente zu diesem Zeitpunkt noch nicht hochladen können, markieren Sie dies untenstehend. Wir werden Ihnen eine entsprechende Aufgabe zuweisen.",
  "startCertification.modulesDetailsStep.fillDetails": "Vollständige Details",
  "startCertification.modulesDetailsStep.header": "Informationen und Dokumente bereitstellen",
  "startCertification.modulesDetailsStep.helperText": "Bitte ergänzen Sie die fehlenden Informationen und laden Sie bitte die erforderlichen Dokumente für die ausgewählten Module hoch.",
  "startCertification.modulesDetailsStep.isRepeater": "Ich bin Repetent",
  "startCertification.modulesDetailsStep.option.kmu": "KMU",
  "startCertification.modulesDetailsStep.option.privathaushalte": "Privat",
  "startCertification.modulesDetailsStep.option": "Option",
  "startCertification.modulesDetailsStep.tableTitle": "Ausgewählte Module",
  "startCertification.modulesDetailsStep.trainingProvider": "Ausbildungsanbieter",
  "startCertification.modulesDetailsStep.willUploadDocsLater": "Dokumente später hochladen",
  "startCertification.moduleSelectionStep.header": "Lehrgang, Modul und Prüfungen wählen",
  "startCertification.moduleSelectionStep.helperText": "Bitte wählen einen Lehrgang und eine Prüfungssession aus, um die Module und Prüfungen zu selektieren, für die Sie sich anmelden wollen.",
  "startCertification.moduleSelectionStep.priceColumn": "Preis in CHF",
  "startCertification.moduleSelectionStep.removeButton": "Entfernen",
  "startCertification.moduleSelectionStep.selectButton": "Auswählen",
  "startCertification.moduleSelectionStep.selectedModules": "Ihre ausgewählten Module",
  "startCertification.paymentAndCompletionStep.actionColumn": "Aktion",
  "startCertification.paymentAndCompletionStep.button.confirm": "Jetzt verbindlich buchen",
  "startCertification.paymentAndCompletionStep.button.confirmed": "Bestätigt",
  "startCertification.paymentAndCompletionStep.button.paid": "Bezahlt",
  "startCertification.paymentAndCompletionStep.button.pay": "Bezahlen",
  "startCertification.paymentAndCompletionStep.freeCancelDate": "kostenlose Stornierung bis ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost1": "Danach ist bei ",
  "startCertification.paymentAndCompletionStep.generalInfo.cost2bold": "unbegründeter Abmeldung die volle Prüfungsgebühr",
  "startCertification.paymentAndCompletionStep.generalInfo.cost3": " zu begleichen.",
  "startCertification.paymentAndCompletionStep.generalInfo.freeCancellation": "Die Anmeldung ist verbindlich. Sie können sich bis zu den oben angegebenen Daten ohne Kostenfolge abmelden.",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsfach/72047_PO_Versicherungsfachleute_D_2022.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.hveFAQLinkText": "FAQ eidg. Fachausweis",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLink": "https://www.vbv.ch/fileadmin/vbv/Dokumente/Bildungsabschluesse/Versicherungsvermittlung/FAQ_Vermi_Pruefungen_de.pdf",
  "startCertification.paymentAndCompletionStep.generalInfo.intermediaryFAQLinkText": "FAQ Versicherungsvermittler",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation1": "Weitere Informationen finden Sie in der ",
  "startCertification.paymentAndCompletionStep.generalInfo.moreInformation2": ".",
  "startCertification.paymentAndCompletionStep.header": "Bezahlung und Abschluss",
  "startCertification.paymentAndCompletionStep.hint": "Bitte beachten Sie, dass Ihr Platz in einem Modul bis zur Bezahlung nicht reserviert wird.",
  "startCertification.paymentAndCompletionStep.messages.transactionCancelled": "Transaktion {id} storniert",
  "startCertification.paymentAndCompletionStep.messages.transactionConfirmed": "Transaktion {id} wurde bestätigt",
  "startCertification.paymentAndCompletionStep.messages.transactionFailed": "Transaktion {id} fehlgeschlagen",
  "startCertification.paymentAndCompletionStep.messages.transactionPaid": "Transaktion {id} ist bezahlt worden",
  "startCertification.paymentAndCompletionStep.messages.wrongTransactionId": "Ungültige Transaktions-ID {id}",
  "startCertification.paymentAndCompletionStep.moduleFullyBooked": "Ausgebucht",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart1": "Dies kann bis zu einer Minute dauern. Diese Nachricht wird automatisch geschlossen, wenn die Zahlung bestätigt wurde.",
  "startCertification.paymentAndCompletionStep.paymentConfirmationMessagePart2": "Wenn nicht, kontaktieren Sie bitte VBV mit der Transaktions-ID: {datatransTrxId}",
  "startCertification.paymentAndCompletionStep.paymentConfirmationTitle": "Warten auf Zahlungsbestätigung, bitte warten",
  "startCertification.paymentAndCompletionStep.removeModule": "Modul entfernen",
  "startCertification.paymentAndCompletionStep.removeModuleConfirmation": "Möchten Sie das Modul entfernen?",
  "startCertification.paymentAndCompletionStep.summary": "Zusammenfassung",
  "startCertification.personalDataStep.header": "Verifizieren der Personalien",
  "startCertification.policyDialog.accept.link": "Datenschutzerklärung/AGB",
  "startCertification.policyDialog.accept.linkUrl": "https://www.vbv.ch/de/datenschutzbestimmungen",
  "startCertification.policyDialog.accept": "Hiermit akzeptiere ich die ",
  "startCertification.policyDialog.text1": "Hiermit nehme ich zur Kenntnis und willige hiermit ein, dass die folgenden Informationen an meinen Arbeitgeber bekanntgegeben werden: Erfolgte Anmeldung zu einer Prüfungssession, einschliesslich Datum der Prüfungssession, die Prüfresultate, einschliesslich Noten/Punkte und ob die Prüfung bestanden oder nicht bestanden wurde, die Registrierung im Register Cicero ",
  "startCertification.policyDialog.text2": "Diese Einwilligung kann jederzeit und frei gegenüber dem Berufsbildungsverband der Versicherungswirtschaft VBV schriftlich oder mit E-Mail an vermittler@vbv-afa.ch widerrufen werden.",
  "startCertification.uploadFilesStep.header": "Dokumente hochladen",
  "table.noRecords": "Keine Datensätze gefunden",
  "task.creationDate": "Erstellungsdatum",
  "task.deadline": "Termin",
  "task.noInfo": "Keine Aufgaben vorhanden",
  "task.state": "Status",
  "task.type": "Aufgabentyp",
  "task.validation.deadlineMustBeLaterThanToday": "Die Deadline muss später sein als heute.",
  "task.validation.typeUnknown": "Aufgaben Typ unbekannt",
  "taskState.done": "Erledigt",
  "taskState.inProgress": "In Bearbeitung",
  "taskState.toDo": "Offen",
  "taskType.cancellation": "Stornierung",
  "taskType.checkAvailability": "Verfügbarkeit mitteilen",
  "taskType.checkCorrectionAvailability": "Verfügbarkeit für Prüfungskorrektur mitteilen",
  "taskType.none": "Keine",
  "taskType.uploadDocuments": "Dokumente hochladen",
  "uploadDocumentsTask.header": "Aufgabe Dokumente hochladen",
  "uploadDocumentsTask.instructions": "Bitte laden Sie alle für dieses Modul erforderlichen Dokumente hoch und schließen Sie die Aufgabe ab, wenn Sie fertig sind.",
  "user.noInfo": "Keine Benutzerinformationen",
  "user.settings": "Einstellungen",
  "userRoomAssignment.assignment": "Rollenzuweisung",
  "userRoomAssignment.label.allExpertsSwitch": "Zeige alle Experten",
  "userRoomAssignment.label.fixed": "Fix",
  "userRoomAssignment.label.fixedCorrectionExperts": "Fixe Korrekturexperten",
  "userRoomAssignment.label.fixedExperts": "Fixe Prüfungsexperten (2x)",
  "userRoomAssignment.label.fixedProctors": "Fixe Aufsichtsexperten (2x)",
  "userRoomAssignment.label.reserve": "Provisorisch",
  "userRoomAssignment.label.reserveCorrectionExperts": "Provisorische Korrekturexperten",
  "userRoomAssignment.label.reserveExperts": "Provisorische Prüfungsexperten",
  "userRoomAssignment.label.reserveProctors": "Provisorische Aufsichtsexperten",
  "userRoomAssignment.label.roomFull": "Raum ist ausgebucht",
  "userRoomAssignment.label.roomOverload": "Raum ist überbucht",
  "userRoomAssignment.placeholder.selectFixedExperts": "Prüfungsexperten zuweisen",
  "userRoomAssignment.placeholder.selectFixedProctors": "Aufsichtsexperten zuweisen",
  "userRoomAssignment.placeholder.selectReserveExperts": "Provisorische Prüfungsexperten zuweisen",
  "userRoomAssignment.placeholder.selectReserveProctors": "Provisorische Aufsichtsexperten zuweisen",
};
